module.exports = __webpack_public_path__ + "assets/img/3_1398_big.5eeb7b38.jpg";